
<template>
    <div class="animated fadeIn">
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))

    export default {
        name: 'ShopContainer',
        components: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
